/**
 * ユーティリティ（共通）
 */
'use strict';

// -------------------------------------------------------
/*
 * MD5ハッシュ生成（外部パッケージ非依存の純JS実装）
 * S3アップロードキーの生成など、暗号強度を必要としない用途で使用する
 */
function md5(input) {
  function rotl(n, c) { return (n << c) | (n >>> (32 - c)); }
  function toHexLE(n) {
    let hex = '';
    for (let i = 0; i < 4; i++) {
      hex += (((n >> (i * 8)) & 0xff) + 0x100).toString(16).slice(1);
    }
    return hex;
  }

  const s = [
    7,12,17,22, 7,12,17,22, 7,12,17,22, 7,12,17,22,
    5, 9,14,20, 5, 9,14,20, 5, 9,14,20, 5, 9,14,20,
    4,11,16,23, 4,11,16,23, 4,11,16,23, 4,11,16,23,
    6,10,15,21, 6,10,15,21, 6,10,15,21, 6,10,15,21,
  ];
  const K = [];
  for (let i = 0; i < 64; i++) K[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 4294967296);

  // UTF-8バイト列化 + パディング
  const utf8 = unescape(encodeURIComponent(String(input)));
  const bytes = [];
  for (let i = 0; i < utf8.length; i++) bytes.push(utf8.charCodeAt(i));

  const bitLen = bytes.length * 8;
  bytes.push(0x80);
  while (bytes.length % 64 !== 56) bytes.push(0);
  for (let i = 0; i < 8; i++) bytes.push((bitLen / Math.pow(2, i * 8)) & 0xff);

  let a0 = 0x67452301, b0 = 0xefcdab89, c0 = 0x98badcfe, d0 = 0x10325476;

  for (let chunkStart = 0; chunkStart < bytes.length; chunkStart += 64) {
    const M = [];
    for (let j = 0; j < 16; j++) {
      M[j] = bytes[chunkStart + j * 4]
        | (bytes[chunkStart + j * 4 + 1] << 8)
        | (bytes[chunkStart + j * 4 + 2] << 16)
        | (bytes[chunkStart + j * 4 + 3] << 24);
    }

    let A = a0, B = b0, C = c0, D = d0;

    for (let i = 0; i < 64; i++) {
      let F, g;
      if (i < 16)      { F = (B & C) | (~B & D);       g = i; }
      else if (i < 32) { F = (D & B) | (~D & C);       g = (5 * i + 1) % 16; }
      else if (i < 48) { F = B ^ C ^ D;                g = (3 * i + 5) % 16; }
      else             { F = C ^ (B | ~D);             g = (7 * i) % 16; }

      F = (F + A + K[i] + M[g]) | 0;
      A = D; D = C; C = B;
      B = (B + rotl(F, s[i])) | 0;
    }

    a0 = (a0 + A) | 0;
    b0 = (b0 + B) | 0;
    c0 = (c0 + C) | 0;
    d0 = (d0 + D) | 0;
  }

  return toHexLE(a0) + toHexLE(b0) + toHexLE(c0) + toHexLE(d0);
}
// -------------------------------------------------------

module.exports = {

  // -------------------------------------------------------
  /*
   * MD5ハッシュ生成
   */
  md5(input) {
    return md5(input);
  },

  // -------------------------------------------------------
  /*
   * リダイレクト処理実行
   */
  redirect(url) {
    location.href = url;
  },

  // -------------------------------------------------------
  /**
   * データが空か確認
   */
  isNull(value) {
    return value == null;
  },

  // -------------------------------------------------------
  /**
   * データの値が正しいか確認
   */
  isValue(value) {
    return value !== '';
  },

  // -------------------------------------------------------
  /**
   * 配列にデータが存在するか確認
   */
  isArray(array, value) {
    return array.includes(value);
  },

  // -------------------------------------------------------
  /*
   * 数字表示（カンマ区切り）
   */
  viewInt(value) {
    const n = Number(value);
    if (!isFinite(n)) return '0';
    return Math.round(n).toLocaleString('ja-JP');
  },

  // -------------------------------------------------------
  /*
   * 数字表示（小数点第一位）
   */
  viewIntFirstDP(value) {
    const n = Number(value);
    if (!isFinite(n)) return '0.0';
    return n.toFixed(1);
  },

  // -------------------------------------------------------
  /*
   * 数字表示（カンマ区切り、プラスマイナス表示）
   */
  viewIntPm(value) {
    if (value > 0) return '+' + this.viewInt(value);
    if (value < 0) return '-' + this.viewInt(value * -1);
    return this.viewInt(value);
  },

  // -------------------------------------------------------
  /*
   * 数字表示（カンマ区切り、バリデーション処理）
   */
  viewIntCustom(value) {
    const val = this.validationNumber(value);
    return val.toLocaleString('ja-JP');
  },

  // -------------------------------------------------------
  /*
   * 数字表示（万単位省略）
   */
  viewScore(value, fixed = 1) {
    if (value == null || Number.isInteger(value) === false) return '-';

    if (value < 100000) {
      return Math.round(value).toLocaleString('ja-JP');
    }
    const score = value / 10000;
    if (score > 1000) {
      return Math.round(score).toLocaleString('ja-JP') + '万';
    }
    return score.toFixed(fixed) + '万';
  },

  // -------------------------------------------------------
  /*
   * 数字のバリデーション処理
   */
  validationNumber(value) {
    return Math.abs(parseInt(Number(value), 10));
  },

  // -------------------------------------------------------
  /*
   * 文字数カウント（バイト数算出）
   * escape() は非推奨のため TextEncoder で代替
   */
  charCount(str) {
    return new TextEncoder().encode(str).length;
  },

  // -------------------------------------------------------
  /*
   * オブジェクトのソート
   */
  sort(obj, key, order = '', key2, order2 = '') {
    obj.sort((a, b) => {
      if (a[key] < b[key]) return order === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return order === 'asc' ? 1 : -1;
      if (key2 != null) {
        if (a[key2] < b[key2]) return order2 === 'asc' ? -1 : 1;
        if (a[key2] > b[key2]) return order2 === 'asc' ? 1 : -1;
      }
      return 0;
    });
    return obj;
  },

  // -------------------------------------------------------
  /*
   * オブジェクトの複製
   */
  copy(obj) {
    return Object.assign({}, obj);
  },

  // -------------------------------------------------------
  /*
   * オブジェクトのマージ
   */
  merge(obj1, obj2) {
    if (!obj2) obj2 = {};
    for (const key in obj2) {
      if (Object.prototype.hasOwnProperty.call(obj2, key)) {
        obj1[key] = obj2[key];
      }
    }
  },

  // -------------------------------------------------------
  /*
   * 配列からデータを削除
   */
  omit(array, key) {
    return array.filter((data) => data !== key);
  },

  // -------------------------------------------------------
  /*
   * 配列・オブジェクトの比較
   */
  diff(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  },

  // -------------------------------------------------------
  /*
   * 数値インデックスをExcel列文字列に変換（例: 1→A, 27→AA）
   */
  getExcelRowString(numeric_col_index) {
    const RADIX = 26;
    const A = 'A'.charCodeAt(0);
    let n = numeric_col_index;
    let s = '';
    while (n >= 1) {
      n--;
      s = String.fromCharCode(A + (n % RADIX)) + s;
      n = Math.floor(n / RADIX);
    }
    return s;
  },

  // -------------------------------------------------------
  /*
   * 配列の重複データを削除
   */
  unique(array) {
    return [...new Set(array)];
  },

  // -------------------------------------------------------
  /*
   * オブジェクトを {id, value} 配列に変換
   */
  convertArray(object, id = 'id', value = 'value') {
    try {
      return Object.keys(object).map((key) => ({
        [id]    : key,
        [value] : object[key],
      }));
    } catch (e) {
      return [];
    }
  },

  // -------------------------------------------------------
  /*
   * クッキーの有効状態を確認（ブラウザ専用）
   */
  cookieEnableCheck() {
    const cookie_name = 'cookie_check';
    document.cookie = cookie_name + '=check';
    return document.cookie.split('; ').some((c) => c.split('=')[0] === cookie_name);
  },

  // -------------------------------------------------------
  /**
   * DBから受け取る日付データを補正
   * moment().format() 代替: Intl.DateTimeFormat / Date メソッドで整形
   */
  setDate(date, format) {
    if (format == null) format = 'YYYY-MM-DD';
    try {
      const d = new Date(date);
      if (isNaN(d.getTime())) return date;

      const pad = (n) => String(n).padStart(2, '0');
      const tokens = {
        YYYY: d.getFullYear(),
        MM:   pad(d.getMonth() + 1),
        M:    d.getMonth() + 1,
        DD:   pad(d.getDate()),
        D:    d.getDate(),
        HH:   pad(d.getHours()),
        H:    d.getHours(),
        mm:   pad(d.getMinutes()),
        m:    d.getMinutes(),
        ss:   pad(d.getSeconds()),
        s:    d.getSeconds(),
      };

      return format.replace(/YYYY|MM|M|DD|D|HH|H|mm|m|ss|s/g, (match) => tokens[match]);
    } catch (e) {
      return date;
    }
  },

  // -------------------------------------------------------
  /**
   * 配列からカラムのリストデータを生成
   */
  createColumnArray(ary, key) {
    const ids = [];
    ary.forEach((d) => { if (!ids.includes(d[key])) ids.push(d[key]); });
    return ids;
  },

  // -------------------------------------------------------
  /**
   * 配列からオブジェクト型を生成
   */
  createColumnObject(ary, key, mode) {
    const obj = {};
    ary.forEach((d) => {
      if (mode === 'array') {
        if (obj[d[key]] == null) obj[d[key]] = [];
        obj[d[key]].push(d);
      } else {
        obj[d[key]] = d;
      }
    });
    return obj;
  },

  // -------------------------------------------------------
  /**
   * 配列にデータを追加、既に存在している場合は外す
   */
  toggleArrayInput(ary, value) {
    const array = [...ary];
    const idx   = array.indexOf(value);
    if (idx === -1) {
      array.push(value);
    } else {
      array.splice(idx, 1);
    }
    return array;
  },

  // -------------------------------------------------------
  /**
   * オブジェクトから配列を生成
   */
  createObjectToArray(obj) {
    return Object.values(obj);
  },

  // -------------------------------------------------------
  /**
   * オブジェクトから {id, value} 配列を生成
   */
  createObjectToArrayRaw(obj) {
    return Object.entries(obj).map(([id, value]) => ({ id, value }));
  },

  // -------------------------------------------------------
  /**
   * 配列にデータを追加する（重複・空文字を除外）
   */
  arrayPush(array, value) {
    if (!array.includes(value)) array.push(value);
    return array.filter((id) => id !== '');
  },

  // -------------------------------------------------------
  /*
   * 送信用のDMテンプレートメッセージ作成
   */
  createDmMessage(template, params) {
    // 名前の置き換え {name}
    if (params.target != null) {
      const name = (params.target.full_name === '' || params.target.full_name == null)
        ? params.target.insta_id
        : params.target.full_name;
      if (name != null) template = template.replace(/\{name\}/ig, name);
    }

    // プロジェクトデータの置き換え
    if (params.project != null) {
      const pjt    = params.project;
      const detail = pjt.detail;

      let title = pjt.title;
      if (detail != null && detail.open_title != null && detail.open_title !== '') title = detail.open_title;
      if (title != null) template = template.replace(/\{title\}/ig, title);

      template = template.replace(/\{project_detail\}/ig,
        (pjt.main_detail != null && pjt.main_detail !== '') ? pjt.main_detail : '××××');

      template = template.replace(/\{project_overview\}/ig,
        (pjt.short_detail != null && pjt.short_detail !== '') ? pjt.short_detail : '××××');

      template = template.replace(/\{guide_url\}/ig,
        (detail != null && detail.post_guide_url != null && detail.post_guide_url !== '')
          ? detail.post_guide_url : '××××');
    }

    // 招待URL {url}
    if (params.unique_code != null) {
      template = template.replace(/\{url\}/ig,
        `https://casting.moribus.jp/invite/${params.unique_code}`);
    }

    // 担当者名 {my_name}
    if (params.userData != null) {
      template = template.replace(/\{my_name\}/ig, params.userData.name);
    }

    // 参考投稿 {post}
    if (params.target != null && params.target.status != null) {
      try {
        const posts = params.target.status.reference_post
          .split(',')
          .filter((id) => id !== '');
        if (posts.length === 0) throw new Error('skip');

        const msg = posts.map((p) => `https://www.instagram.com/p/${p}\n`).join('');
        if (msg !== '') template = template.replace(/\{post\}/ig, '■参考投稿\n' + msg);
      } catch (e) {}
    }
    template = template.replace(/\{post\}/ig, '');

    return template;
  },

};